// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingTermsStateCell_container__3FohP","round":"SettingTermsStateCell_round__2xwmG"};